module.exports = __webpack_public_path__ + "static/media/game1.35ebb172.jpg";